const REDIRECT_URI_PROFILE = '/profile';

export const redirects = {
    REDIRECT_URI_LOGIN: '/login',
    REDIRECT_URI_PROFILE,
    REDIRECT_URI_GARAGE: '/garage',
    REDIRECT_URI_AFTER_LOGIN: REDIRECT_URI_PROFILE,
};

export const authenticationStatuses = {
    STATUS_AUTHENTICATED: 'authenticated',
    STATUS_NOT_AUTHENTICATED: 'not-authenticated',
};

export const storage = {
    AUTH_TOKEN: 'authToken',
    NEXT_URI: 'drivek.nexturi',
};
